/*
 Translation file: Please keep utf8 encoding.
*/


export const languageMeta = {
  es: {
    label: "Español",
    code3: "esp"
  },
  en: {
    label: "English",
    code3: "eng"
  },
  /* Comming soon */
  fr: {
    label: "Français",
    code3: "fra"
  }, 
};

const translations = {
  
  es: {
    PRICE: 15,
    PRICE_BY_MONTH: 2,
    MONEY_SYMBOL: "€",
    // Index
    LOGO_TEXT: "Readerum.com",
    INDEX_LOGOUT_BUTTON: "Cerrar sesión",
    MAIN_TEXT1: "Lee o escucha libros sin lí­mites y con herramientas lingü­sticas.",
    MAIN_TEXT2: "Disfruta en cualquier lugar y cancela cuando quieras.",
    MAIN_TEXT3: "Por sólo {PRICE} {MONEY_SYMBOL} al año (Unos {PRICE_BY_MONTH} {MONEY_SYMBOL} al mes)",
    MAIN_WELCOME_TEXT: "¡Bienvenido, {USER}!",
    MAIN_ENTRY_BUTTON: "Entrar a la biblioteca",
    MAIN_EXPLORE_FREE_BUTTON: "Explorar Libros Gratis",

    // COMPONENTES
    // Paywall
    PAYWALL_TITLE: "¡La aventura no termina aquí!",
    PAYWALL_MESSAGE: "Has completado el capítulo de cortesía. Únete a Readerum para desbloquear el resto del libro, guardar tu progreso y acceder a herramientas lingüísticas avanzadas.",
    PAYWALL_REGISTER_BTN: "Crear Cuenta Gratis",
    PAYWALL_LOGIN_BTN: "Iniciar Sesión",
    PAYWALL_BACK_BTN: "Volver al catálogo",
    PAYWALL_FREE_LIST_TITLE: "¡Amplía tu biblioteca!",
    PAYWALL_FREE_LIST_MESSAGE: "En el plan gratuito puedes leer un libro completo a la vez. Agrega este libro a tu lista de lectura para desbloquearlo, o hazte Premium para leer todo el catálogo de manera ilimitada.",
    PAYWALL_GO_TO_LIST_BTN: "Ver Mi Lista",
    PAYWALL_AUDIO_PREMIUM_TITLE: "¡Sigue escuchando!",
    PAYWALL_AUDIO_PREMIUM_MESSAGE: "La lectura inmersiva con audio sincronizado y voz profesional a partir del capítulo 4 es una característica exclusiva de Readerum Premium. ¡Sube de nivel para continuar la inmersión!",
    PAYWALL_DICT_LIMIT_TITLE: "¡Aprende sin límites!",
    PAYWALL_DICT_LIMIT_MESSAGE: "Has alcanzado tu límite gratuito de 5 consultas diarias de diccionario. Consigue consultas de vocabulario ilimitadas, transcripción fonológica avanzada y más con Readerum Premium.",
    BOOKINFO_LOGIN_REQUIRED_FOR_LIST: "Inicia sesión para guardar libros en tu lista.",

    // FAQ Accordion
    INDEX_FAQ_TITLE: "Preguntas frecuentes",
    INDEX_FAQ_QUESTION1: "¿Qué es Readerum?",
    INDEX_FAQ_ANSWER1: "Raeaderum es una plataforma de lectura donde podrás encontrar todo tipo de libros que pone a disposición del lector, dicionarios, fonologí­a y lectura automática.",
    INDEX_FAQ_QUESTION2: "¿Cómo puedo acceder a Readerum?",
    INDEX_FAQ_ANSWER2: "Puedes acceder a Readerum a través de tu cuenta de correo-e o de tus redes sociales favoritas.",
    INDEX_FAQ_QUESTION3: "¿Cuánto cuesta Readerum?",
    INDEX_FAQ_ANSWER3: "Readerum cuesta {PRICE} {MONEY_SYMBOL} al año, lo que equivale a unos {PRICE_BY_MONTH} {MONEY_SYMBOL} al mes.",
    INDEX_FAQ_QUESTION4: "¿En qué dispositivos puedo usar Readerum?",
    INDEX_FAQ_ANSWER4: "Puedes usar Readerum en cualquier dispositivo con conexión a internet y un navegador web.",
    INDEX_FAQ_QUESTION5: "¿Hay algún tipo de compromiso de permanencia al suscribirse?",
    INDEX_FAQ_ANSWER5: "No, puedes cancelar tu suscripción en cualquier momento. La cancelación surtirá efecto cuando termine tu periodo de facturación.",
    INDEX_FAQ_QUESTION6: "¿Cómo cancelo el servicio?",
    INDEX_FAQ_ANSWER6: "Readerum no tiene contratos de permanencia. Puedes cancelar fácilmente tu cuenta en lí­nea con unos pocos clics y sin cargos adicionales. Puedes activar o cancelar tu cuenta en cualquier momento.",   
    // Dispositivos disponibles
    DEVICES_TITLE: "Dispositivos disponibles",
    DEVICES_GOOGLE_PLAY_TITLE: "Google Play",
    DEVICES_GOOGLE_PLAY_DESC: "Disponible en Google Play",
    DEVICES_WEB_TITLE: "Navegador web",
    DEVICES_WEB_DESC: "Disponible en cualquier navegador moderno",
    DEVICES_ANDROID_TV_TITLE: "Android TV",
    DEVICES_ANDROID_TV_DESC: "Compatible con Android TV",
    // Formulario de contacto
    CONTACT_FORM_TITLE: "Contacta con nosotros",
    CONTACT_FORM_DESC: "¿Tienes alguna pregunta o problema? ¡Estamos aquí­ para ayudarte! Por favor, rellena el siguiente formulario y nos pondremos en contacto contigo lo antes posible.",
    CONTACT_FORM_NAME: "Nombre",
    CONTACT_FORM_EMAIL: "Correo electrónico",
    CONTACT_FORM_MESSAGE: "Mensaje",
    CONTACT_FORM_MESSAGE_PLACEHOLDER: "Escribe aquí­ tu mensaje...",
    CONTACT_FORM_SUBMIT: "Enviar",
    CONTACT_FORM_ERROR: "Por favor, rellena todos los campos.",
    CONTACT_FORM_INVALID_EMAIL: "Por favor, introduce una dirección de correo-e válida.",
    CONTACT_FORM_SUBMIT_ERROR: "Ha ocurrido un error al enviar el formulario. Por favor, inténtalo de nuevo más tarde.",
    CONTACT_FORM_SUBMIT_SUCCESS: "¡Mensaje enviado con éxito! Nos pondremos en contacto contigo lo antes posible.",
    CONTACT_FORM_ENCOURAGEMENT: "¡Tu opinión es muy importante para nosotros! Cuéntanos cómo podemos mejorar.",
    // Footer
    FOOTER_INDEX: "Inicio",
    FOOTER_PRIVACY: "Polí­tica de privacidad",
    FOOTER_TERMS_OF_USE: "Términos de uso",
    FOOTER_CUSTOMER: "Atención al cliente",
    FOOTER_HELP_US: "Ayúdanos a mejorar",
    FOOTER_ABOUT_US: "Acerca de nosotros",
    FOOTER_COPYRIGHT: "Todos los derechos reservados",
    FOOTER_READERUM_TEXT: "Readerum.com (c) 2025",

    // Login
    LOGIN_TITLE: "Iniciar sesión",
    LOGIN_EMAIL: "Correo electrónico",
    LOGIN_PASSWORD: "Contraseña",
    LOGIN_BUTTON: "Ingresar",
    LOGIN_GOOGLE: "Iniciar con Google",
    LOGIN_FACEBOOK: "Iniciar con Facebook",
    LOGIN_NO_ACCOUNT: "¿No tienes una cuenta?",
    LOGIN_REGISTER: "Regí­strate aquí­",
    LOGIN_LOADING: "Cargando...",
    LOGIN_ERROR_USER_NOT_FOUND: "Usuario no encontrado. Por favor, verifica tus credenciales.",
    LOGIN_ERROR_WRONG_PASSWORD: "Contraseña incorrecta. Por favor, verifica tus credenciales.",
    LOGIN_ERROR_INVALID_EMAIL: "Correo-e inválido. Por favor, verifica tu dirección de correo-e.",
    LOGIN_ERROR_EMAIL_ALREADY_IN_USE: "El correo-e ya está en uso. Por favor, prueba con otro.",
    LOGIN_ERROR_WEAK_PASSWORD: "La contraseña es débil. Por favor, elige una contraseña más segura.",
    LOGIN_ERROR_DEFAULT: "Ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.",

    // Register
    REGISTER_TITLE: "Regístrarse",
    REGISTER_EMAIL: "Correo electrónico",
    REGISTER_PASSWORD: "Contraseña",
    REGISTER_BUTTON: "Crear cuenta",
    REGISTER_HAVE_ACCOUNT: "¿Ya tienes una cuenta?",
    REGISTER_LOGIN: "Inicia sesión aquí­",
    REGISTER_FIRST_NAME: "Nombre",
    REGISTER_LAST_NAME: "Apellido",
    REGISTER_LOADING: "Cargando...",
    REGISTER_ERROR_WEAK_PASSWORD: "La contraseña es débil. Por favor, elige una contraseña más segura.",
    REGISTER_ERROR_INVALID_EMAIL: "Correo-e inválido. Por favor, verifica tu dirección de correo-e.",
    REGISTER_ERROR_EMAIL_ALREADY_IN_USE: "El correo-e ya está en uso. Por favor, prueba con otro.",
    REGISTER_ERROR_DEFAULT: "Ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.",
    REGISTER_SUCCESS: "¡Cuenta creada con éxito! Por favor, inicia sesión para continuar.",

    // Pricing
    PRICING_HEADER_TITLE: "Lee, escucha y aprende de una nueva forma.",
    PRICING_HEADER_SUBTITLE: "Readerum te acompaña en cada palabra: lectura, audio y diccionario en un solo lugar.",
    PRICING_FOOTER_NOTE: "Los limites pueden variar por país o campaña. Impuestos incluidos donde aplique.",
    PRICING_PLAN_FREE_NAME: "Free",
    PRICING_PLAN_FREE_DESCRIPTION: "Prueba completa con limites mensuales.",
    PRICING_PLAN_FREE_BADGE: "Popular",
    PRICING_PLAN_FREE_FEATURE_BOOKS: "1 libro completo por mes",
    PRICING_PLAN_FREE_FEATURE_AUDIO: "Audio completo (sin control de velocidad)",
    PRICING_PLAN_FREE_FEATURE_DICTIONARY: "Diccionario ilimitado en esas lecturas",
    PRICING_PLAN_FREE_FEATURE_SYNC: "Sincronización de la barra de progreso",
    PRICING_PLAN_FREE_FEATURE_CUSTOMIZATION: "Personalización básica",
    PRICING_PLAN_FREE_PRICE: "0 {MONEY_SYMBOL}",
    PRICING_PLAN_FREE_NOTE: "Requiere registro",
    PRICING_PLAN_FREE_CTA: "Usar plan Free",
    PRICING_PLAN_PREMIUM_NAME: "Premium",
    PRICING_PLAN_PREMIUM_DESCRIPTION: "Lecturas ilimitadas y funciones avanzadas.",
    PRICING_PLAN_PREMIUM_BADGE: "Todo incluido",
    PRICING_PLAN_PREMIUM_FEATURE_LIBRARY: "Catalogo y audio ilimitados",
    PRICING_PLAN_PREMIUM_FEATURE_SPEED: "Control de velocidad 0.5-1.5x y autoplay",
    PRICING_PLAN_PREMIUM_FEATURE_HIGHLIGHT: "Subrayado palabra a palabra en todo el texto",
    PRICING_PLAN_PREMIUM_FEATURE_STATS: "Estadísticas de lectura",
    PRICING_PLAN_PREMIUM_FEATURE_FONOLOGY: "Texto fonológico en los idiomas disponibles",
    PRICING_PLAN_PREMIUM_FEATURE_COLLECTIONS: "Colecciones premium y soporte prioritario",
    PRICING_PLAN_PREMIUM_PRICE: "4,99 {MONEY_SYMBOL}",
    PRICING_PLAN_PREMIUM_PERIOD: "mes",
    PRICING_PLAN_PREMIUM_NOTE: "o 39,99 {MONEY_SYMBOL} / año",
    PRICING_PLAN_PREMIUM_CTA: "Hazte Premium",

    // PRIVACY POLICY
    PRIVACY_TITLE: "Polí­tica de privacidad",
    PRIVACY_DATE_DESC: "Última actualización:",
    PRIVACY_DATE: "2025-03-22",
    PRIVACY_EMAIL: "privacy@readerum.com",
    PRIVACY_RESUME: "En Readerum, la privacidad y la seguridad de tus datos son nuestra máxima prioridad. A continuación, te explicamos cómo recopilamos, almacenamos y utilizamos tus datos personales. Si tienes alguna pregunta o inquietud, no dudes en ponerte en contacto con nosotros.",
    PRIVACY_TEXT: "<li><strong>¿Quién es el responsable del tratamiento de tus datos?</strong>\n " +
    "Readerum es el responsable del tratamiento de los datos personales. Puedes contactar a nuestro Delegado de Protección de Datos en cualquier momento a través del correo electrónico {PRIVACY_EMAIL}." +
    "</li>\n" +

    "<li><strong>¿Qué datos recopilamos?</strong>\n"+
    "Solo recopilamos los datos necesarios para prestarte el servicio de forma eficiente y personalizada. Esto incluye:" +
    "<ul>" +
      "<li>Datos de autenticación: cuando inicias sesión con Google o Facebook (a través de Firebase), recopilamos tu nombre, correo electrónico y foto de perfil pública. Nunca accedemos ni almacenamos tu contraseña." +
      "<li>Preferencias de lectura: como la velocidad del audio, tamaño de fuente, idioma preferido o diccionario utilizado." +
      "<li>Datos técnicos: tipo de dispositivo, sistema operativo, y versión de la aplicación para análisis y soporte técnico." +
      "<li>Datos de uso anónimos o agregados: para mejorar el rendimiento y funcionalidad del servicio." +
      "<li>No recolectamos información sensible (como ubicación precisa, número de teléfono, dirección, información financiera o médica)." +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>¿Para qué usamos tus datos?</strong>\n" +
    "Utilizamos tus datos personales para:" +
    "<ul>" +
      "<li>Permitir y gestionar el inicio de sesión y la autenticación." +
      "<li>Guardar tus preferencias para personalizar tu experiencia." +
      "<li>Realizar análisis técnicos y funcionales que mejoren el servicio." +
      "<li>Comunicarnos contigo si es necesario (por ejemplo, soporte o actualizaciones importantes)." +
      "<li>Cumplir con obligaciones legales." +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>¿Con quién compartimos tus datos?</strong>\n" +
    "Readerum no vende ni alquila tus datos personales. Solo los compartimos con terceros cuando:" +
    "<ul>" +
      "<li>Es necesario para el funcionamiento de la plataforma, como los servicios de Firebase (Google), que proveen autenticación, hosting y base de datos.</li>" +
      "<li>Lo exige la ley, una autoridad judicial o administrativa.</li>" +
      "<li>Se realiza una fusión, adquisición o cambio de control, caso en el cual te informaremos con antelación.</li>" +
      "<li>Todos los terceros cumplen con estándares de seguridad y privacidad equivalentes a los nuestros.</li>" +
    "</ul>" +
    "</li>\n" +

    "<li><strong>¿Dónde y por cuánto tiempo almacenamos tus datos?</strong>\n" +
    "Tus datos son almacenados en servidores seguros de Firebase (ubicados en EE.UU. u otras regiones con garantí­as adecuadas de protección de datos). Mantendremos tus datos solo durante el tiempo necesario para cumplir los fines descritos en esta polí­tica, o hasta que solicites su eliminación." +
    "</li>\n" +
    
    "<li><strong>¿Cuáles son tus derechos?</strong>\n" +
    "Tienes derecho a:" +
    "<ul>"+
      "<li>Acceder a tus datos personales." +
      "<li>Corregirlos o actualizarlos." +
      "<li>Solicitar su eliminación (derecho al olvido)." +
      "<li>Revocar tu consentimiento." +
      "<li>Solicitar la portabilidad de tus datos." +
      "<li>Para ejercer estos derechos, escrí­benos al correo-e {PRIVACY_EMAIL}. Si estás en Colombia, puedes presentar una queja ante la Superintendencia de Industria y Comercio (SIC). Si estás en la UE, puedes hacerlo ante tu autoridad local de protección de datos." +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>Menores de edad</strong>\n" +
    "Readerum no está dirigida a menores de 13 años. No recopilamos intencionalmente datos de niños. Si detectamos que hemos almacenado datos de un menor sin el consentimiento de sus padres o tutores, procederemos a eliminarlos inmediatamente." +
    "</li>\n" +

    "<li><strong>Cookies y tecnologí­as similares</strong>" +
    "En la versión web de Readerum se pueden usar cookies o tecnologí­as similares para:" +
    "<ul>" +
      "<li>Recordar tus preferencias.</li>" +
      "<li>Analizar el uso del sitio.</li>" +
      "<li>Mejorar el rendimiento.</li>" +
      "<li>Puedes controlar el uso de cookies desde la configuración de tu navegador.</li>" +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>Cambios en esta polí­tica</strong>\n" + 
    "Podemos actualizar esta polí­tica en el futuro. Si realizamos cambios significativos, te lo notificaremos a través de la aplicación o por correo electrónico." +
    "</li>\n",

    // TERMS OF USE
    TERMS_OF_USE_TITLE: "Términos y condiciones de uso",
    TERMS_OF_USE_RESUME: "Bienvenido a Readerum. Al acceder o utilizar nuestra plataforma de lectura en lí­nea, aceptas cumplir y estar sujeto a los presentes Términos y condiciones de uso. Si no estás de acuerdo con alguno de ellos, por favor no utilices el sitio ni los servicios.",
    TERMS_OF_USE_DATE: "2025-03-22",
    TERMS_DATE_DESC: "Última actualización: {TERMS_OF_USE_DATE}",
    TERMS_OF_USE_TEXT: "<ol>" +
    "<li><strong>Descripción del servicio.</strong> " +
      "Readerum es una plataforma en lí­nea que ofrece una amplia selección de libros en varios idiomas. Nuestro objetivo es fomentar la lectura y el aprendizaje a través de una experiencia de usuario sencilla, atractiva y accesible desde cualquier dispositivo con conexión a internet." +
    "</li>\n"+
    "<li><strong>Registro y acceso.</strong> " +
      "Algunas funcionalidades pueden requerir la creación de una cuenta personal." +
      "Al registrarte, te comprometes a proporcionar información veraz, completa y actualizada." + 
      "Eres responsable de mantener la confidencialidad de tus credenciales de acceso y de todas las actividades que ocurran bajo tu cuenta." +
    "</li>\n"+
    "<li><strong>Uso adecuado</strong> " +
    "Al usar Readerum, te comprometes a:" +
      "<ul>" +
        "<li>No utilizar la plataforma para fines ilegales o no autorizados." +
        "<li>No copiar, reproducir o distribuir el contenido sin autorización, salvo que se indique lo contrario." +
        "<li>No interferir con el funcionamiento normal del sitio web ni realizar acciones que puedan comprometer su seguridad o estabilidad." +
      "</ul>" +
    "</li>\n" +
    "<li><strong>Propiedad intelectual.</strong> " +
      "Todo el contenido disponible en Readerum (textos, imágenes, interfaz, código, etc.) es propiedad de Readerum o de sus respectivos licenciantes." +
      "El uso del contenido está restringido a fines personales y educativos, salvo acuerdo expreso para otros usos." +
    "</li>\n" +
    "<li><strong>Contenido de terceros</strong> " +
      "Readerum puede incluir enlaces, referencias o contenido proporcionado por terceros. No somos responsables por el contenido, polí­ticas o prácticas de sitios externos." +
    "</li>\n" +
    "<li><strong>Disponibilidad del servicio. </strong>" +
      "Readerum hace esfuerzos razonables por garantizar la disponibilidad continua del servicio, pero no se responsabiliza por interrupciones temporales, fallos técnicos o cualquier otra situación que impida el acceso al sitio." +
    "</li>\n" +
    "<li><strong>Modificaciones.</strong> " +
    "Nos reservamos el derecho de modificar estos términos en cualquier momento. En caso de cambios sustanciales, notificaremos a los usuarios a través de la plataforma o por correo electrónico. El uso continuado del servicio después de dichas modificaciones implicará la aceptación de los nuevos términos." +
    "</li>\n" +
    "<li><strong>Terminación.</strong> " +
      "Readerum puede suspender o cancelar tu acceso a la plataforma, de forma temporal o definitiva, si incumples estos términos o si se detecta un uso inadecuado del servicio." +
    "</li>\n" +
    "<li><strong>Limitación de responsabilidad</strong> " +
      "Readerum no será responsable por daños directos, indirectos, incidentales o consecuentes derivados del uso o la imposibilidad de uso del servicio. El acceso a Readerum se ofrece â€œtal cualâ€ y â€œsegún disponibilidad.â€" +
    "</li>\n" +
    "<li><strong>Legislación aplicable y jurisdicción.</strong> " +
      "Estos términos se rigen por las leyes de la República de Colombia. En caso de controversias, las partes se someten a la jurisdicción de los tribunales competentes de la ciudad de Bogota." +
    "</li>",
    // CUSTOMER SUPPORT
    CUSTOMER_SUPPORT_TITLE: "Atención al cliente",
    CUSTOMER_SUPPORT_TEXT: "Bienvenido a nuestro centro de soporte al cliente. Estamos aquí­ para ayudarte con cualquier pregunta o problema que puedas tener. Encuentra respuestas rápidas en nuestras Preguntas Frecuentes o contacta con nuestro equipo de atención al cliente.",
    // HELP US IMPROVE
    HELP_US_TITLE: "Ayúdanos a mejorar",
    HELP_US_TEXT: "En Readerum, estamos comprometidos a mejorar continuamente nuestra plataforma para ofrecerte la mejor experiencia de lectura posible. Si tienes alguna sugerencia, comentario o problema, por favor, háznoslo saber.",
    // ABOUT US
    ABOUT_US_TITLE: "Acerca de nosotros",
    ABOUT_US_TEXT: "Readerum es una plataforma de lectura en lí­nea que ofrece una amplia selección de libros en varios idiomas. Nuestro objetivo es fomentar la lectura y el aprendizaje a través de una experiencia de usuario sencilla y atractiva. Haciendo que la lectura sea accesible y dinámica para todos.",
    


    


    // HOME
    // Navbar
    HOME_MENU_HOME: "INICIO",
    HOME_MENU_MY_LIST: "MI LISTA",
    HOME_MENU_SEARCH: "BUSCAR",
    HOME_MENU_SETTINGS: "Configuración",
    HOME_LOGOUT_BUTTON: "Cerrar sesión",
    // GLOBAL SETTTINGS
    SETTINGS_PANEL_TITLE: "Configuración global",
    SETTINGS_LANGUAGE_LABEL: "Idioma de la interfaz",
    SETTINGS_LANGUAGE_SPANISH: "Español",
    SETTINGS_LANGUAGE_ENGLISH: "Inglés",
    SETTINGS_FEEDBACK_CTA: "Ayúdanos a mejorar",
    SETTINGS_FEEDBACK_TITLE: "Queremos escuchar tu opinión",
    // Tags (Given for the API)
    MOST_READ_LABEL: "Más leí­dos",
    LASTEST_LABEL: "Subidos recientemente",
    LASTEST_LABEL1: "Subidos recientemente1",
    LASTEST_LABEL2: "Subidos recientemente2",

    // Book info
    SHOW_BOOK_RESUME: "Ver resumen",
    HIDE_BOOK_RESUME: "Ver resumen",
    BOOKINFO_STATUS_LABEL: "Estado en Mi Lista",
    BOOKINFO_ADD_BUTTON: "Guardar",
    BOOKINFO_ADDING: "Guardando...",
    BOOKINFO_ADD_SUCCESS: "Libro guardado en tu lista.",
    BOOKINFO_ADD_ERROR: "No pudimos guardar el libro. Inténtalo de nuevo.",

    // Book chapter
    // Menú
    CHAPTER_BACK: "Regresar",
    CHAPTER_PLAY: "Reproducir",
    CHAPTER_PREV: "Anterior",
    CHAPTER_NEXT: "Siguiente",
    // Menu settings
    CHAPTER_SETTINGS_TITLE: "Preferencias",
    CHAPTER_SETTINGS_AUDIO: "Audio",
    CHAPTER_SETTINGS_DICTIONARY: "Diccionario",
    CHAPTER_SETTINGS_TEXT: "Texto",
    CHAPTER_DIALECT: "Dialecto",
    CHAPTER_DIALECT_ICON: "Ícono de dialecto",
    CHAPTER_SPEED: "Velocidad",
    CHAPTER_SPEED_ICON: "Ícono de velocidad",
    CHAPTER_AUTO_PLAY: "Reproducción automática",
    CHAPTER_AUTO_PLAY_ICON: "Ícono de autoreproducción",
    CHAPTER_AUTO_PLAY_DESC: "Al finalizar un capí­tulo, el siguiente comienza automáticamente.",
    CHAPTER_DICTIONARY_LAGUAGE: "Lengua del diccionario",
    CHAPTER_DICTIONARY_LAGUAGE_ICON: "Ícono del diccionario",
    CHAPTER_SHOW_PHONOLOGY: "Fonologí­a",
    CHAPTER_SHOW_PHONOLOGY_ICON: "Ícono de Fonología",
    CHAPTER_SHOW_PHONOLOGY_DESC: "Muestra la fonologí­a debajo de cada palabra del texto.",
    CHAPTER_TEXT_SIZE: "Tamaño del texto",
    CHAPTER_TEXT_SIZE_ICON: "Ícono del tamaño de texto",
    CHAPTER_AUTOSCROLL_RESUME: "Activar auto desplzamiento",
    CHAPTER_TS_CHARACTER: "A",

    // Sonido Ambiental
    AMBIENT_TITLE: "Sonido Ambiental",
    AMBIENT_OFF: "Apagado",
    AMBIENT_RAIN: "Lluvia",
    AMBIENT_FOREST: "Bosque",
    AMBIENT_FIREPLACE: "Chimenea",
    AMBIENT_CAFE: "Cafetería",
    AMBIENT_SEA: "Mar",

    // ERRORS
    CHAPTER_ERROR_GETTING_DATA: "Error al obtener datos del capí­tulo",
    CHAPTER_UNKNOWN_ERROR_GETTING_DATA: "Error desconocido al obtener datos del capí­tulo",
    CHAPTER_ERROR_LOADING_AUDIO_DATA_FOR_NEW_DIALECT: 'Error al cargar datos de audio para el nuevo dialecto',
    CHAPTER_ERROR_AUTOPLAY_AUDIO: "Error al intentar reproducir el audio automáticamente:",  
    // Modal definition
    LEMMA_MODAL_LOADING: "Cargando...",
    LEMMA_MODAL_CLOSE: "Cerrar y continuar",
    LEMMA_MODAL_JUST_CLOSE: "Cerrar sin continuar audio",
    LEMMA_MODAL_NOT_FOUND: "Lema no encontrado.",
    LEMMA_MODAL_API_ERROR: "Error de API.",
    LEMMA_MODAL_NETWORK_ERROR: "Error de red.",
    LEMMA_MODAL_NO_DATA: "No hay datos disponibles.",
    LEMMA_MODAL_PROPER_NOUNS: "Nombres propios",
    LEMMA_MODAL_ETYM: "Etimología",
    LEMMA_MODAL_MORPH: "Morfología",
    LEMMA_MODAL_ROOT: "Raíz",
    LEMMA_MODAL_VIEW_PLANAR: "Plano",
    LEMMA_MODAL_VIEW_FRACTAL: "Fractal (IA)",
    LEMMA_MODAL_SHOW_DETAILS: "Ver detalles lingüísticos",
    LEMMA_MODAL_HIDE_DETAILS: "Ocultar detalles",
    // Dialect translations
    'es-ES': "Español (España)",
    'es-419': "Español (Latinoamérica)",

    // Login Modal
    INDEX_LOGIN_TITLE: "Ingresar",
    INDEX_EXTERNAL_LOGIN: "Ingresar con {PLATFORM}",
    INDEX_LOGIN_WITH_EMAIL: "Regí­strate con tu correo-e",
    INDEX_LOGIN_BUTTON: "Ingresar",
    INDEX_HAVE_AN_ACCOUNT: "¿Ya tienes una cuenta con tu correo?",
    INDEX_LOGIN_TEXT: "Inicia sesión",


    // Search
    SEARCH_TITLE: "Busca tu próxima lectura",
    SEARCH_SUBTITLE: "Escribe el tí­tulo, autor o palabra clave para explorar la biblioteca.",
    SEARCH_PLACEHOLDER: "Buscar por tí­tulo, autor o tema",
    SEARCH_BUTTON: "Buscar",
    SEARCH_RESULTS_TITLE: "Resultados",
    SEARCH_RESULTS_EMPTY: "No encontramos coincidencias para \"{QUERY}\".",
    SEARCH_RESULTS_SUGGESTION: "Prueba con otros términos o revisa las recomendaciones destacadas.",
    SEARCH_RESULT_LANGUAGE: "Idioma",
    SEARCH_RESULT_CATEGORY: "Categorí­a",
    SEARCH_RESULT_VIEW: "Ver libro",
    SEARCH_RESULTS_COUNT_LABEL: "Se encontraron {COUNT} resultados:",
    SEARCH_MIN_CHARS_HINT: "Escribe al menos 4 caracteres para iniciar la búsqueda.",
    SEARCH_GENERIC_ERROR: "No pudimos completar la búsqueda. Inténtalo de nuevo.",
    SEARCH_RESULT_UNTITLED: "Sin tí­tulo",
    SEARCH_RESULT_LANGUAGE_UNKNOWN: "Idioma desconocido",
    SEARCH_RESULT_CATEGORY_UNKNOWN: "Sin categorí­a",
    // SEARH API RESPONSES
    API_NO_BOOKS_FOUND: "No se encontraron libros relacionados con tu búsqueda.",


    // LIST
    LIST_TITLE: "Mi lista",
    LIST_INTRO: "Tienes {TOTAL} libros en tu biblioteca personal.",
    LIST_SUMMARY_QUEUED: "En espera",
    LIST_SUMMARY_QUEUED_HINT: "Libros por leer.",
    LIST_SUMMARY_IN_PROGRESS: "En progreso",
    LIST_SUMMARY_IN_PROGRESS_HINT: "Leyendo actualmente.",
    LIST_SUMMARY_FINISHED: "Terminados",
    LIST_SUMMARY_FINISHED_HINT: "Libros completados.",
    LIST_FILTER_TITLE: "Encuentra el próximo libro",
    LIST_FILTER_SEARCH_LABEL: "Buscar",
    LIST_FILTER_SEARCH_PLACEHOLDER: "Tí­tulo o autor",
    LIST_FILTER_SEARCH_BUTTON: "Ir",
    LIST_FILTER_LANGUAGE_LABEL: "Idioma",
    LIST_FILTER_LANGUAGE_ALL: "Todos los idiomas",
    LIST_FILTER_STATUS_LABEL: "Estado",
    LIST_FILTER_STATUS_ALL: "Todos los estados",
    LIST_FILTER_STATUS_IN_PROGRESS: "En progreso",
    LIST_FILTER_STATUS_FINISHED: "Terminado",
    LIST_FILTER_STATUS_QUEUED: "En espera",
    LIST_FILTER_SORT_LABEL: "Ordenar por",
    LIST_FILTER_SORT_RECENT: "Último acceso",
    LIST_FILTER_SORT_TITLE: "Tí­tulo (A-Z)",
    LIST_FILTER_SORT_AUTHOR: "Autor (A-Z)",
    LIST_FILTER_SORT_STATUS: "Estado",
    LIST_FEATURED_TITLE: "Retoma donde lo dejaste",
    LIST_FEATURED_SUBTITLE: "Última lectura: {DATE}",
    LIST_BOOKS_SECTION_TITLE: "Tu biblioteca guardada",
    LIST_BOOKS_SECTION_COUNT: "{COUNT} libros",
    LIST_EMPTY_TITLE: "No encontramos coincidencias",
    LIST_EMPTY_SUBTITLE: "Prueba con otro filtro o busca en toda la biblioteca.",
    LIST_CARD_REMOVE: "Quitar",
    LIST_CARD_REMOVING: "Quitando...",
    LIST_STATUS_IN_PROGRESS: "En progreso",
    LIST_STATUS_FINISHED: "Terminado",
    LIST_STATUS_QUEUED: "En cola",
    LIST_STATUS_NOT_STARTED: "No iniciado",
    LIST_LOADING: "Cargando tu lista...",
    LIST_ERROR: "No pudimos cargar tu lista. Inténtalo de nuevo més tarde.",
    LIST_REMOVE_SUCCESS: "Libro eliminado de tu lista.",
    LIST_REMOVE_ERROR: "No pudimos quitar el libro. Intentalo de nuevo.",
  },
  
  
  
  
  









  // English
  en: {
    PRICE: 15,
    PRICE_BY_MONTH: 2,
    MONEY_SYMBOL: "$",
    // Index
    LOGO_TEXT: "Readerum.com",
    INDEX_LOGOUT_BUTTON: "Log out",
    MAIN_TEXT1: "Read or listen to books without limits and with linguistic tools.",
    MAIN_TEXT2: "Enjoy anywhere and cancel whenever you want.",
    MAIN_TEXT3: "For only {PRICE} {MONEY_SYMBOL} per year (about {PRICE_BY_MONTH} {MONEY_SYMBOL} per month)",
    MAIN_WELCOME_TEXT: "Welcome, {USER}!",
    MAIN_ENTRY_BUTTON: "Enter the library",
    MAIN_EXPLORE_FREE_BUTTON: "Explore Free Books",

    // COMPONENTES
    // Paywall
    PAYWALL_TITLE: "The adventure doesn't end here!",
    PAYWALL_MESSAGE: "You've completed the complimentary chapter. Join Readerum to unlock the rest of the book, save your progress, and access advanced linguistic tools.",
    PAYWALL_REGISTER_BTN: "Create Free Account",
    PAYWALL_LOGIN_BTN: "Log In",
    PAYWALL_BACK_BTN: "Back to catalogue",
    PAYWALL_FREE_LIST_TITLE: "Expand your library!",
    PAYWALL_FREE_LIST_MESSAGE: "In the free plan, you can read one full book at a time. Add this book to your reading list to unlock it, or go Premium to read the entire catalog without limits.",
    PAYWALL_GO_TO_LIST_BTN: "View My List",
    PAYWALL_AUDIO_PREMIUM_TITLE: "Keep listening!",
    PAYWALL_AUDIO_PREMIUM_MESSAGE: "Immersive reading with synchronized professional audio from Chapter 4 onwards is a Readerum Premium exclusive feature. Upgrade to continue your journey!",
    PAYWALL_DICT_LIMIT_TITLE: "Learn without limits!",
    PAYWALL_DICT_LIMIT_MESSAGE: "You've reached your free limit of 5 daily dictionary queries. Get unlimited vocabulary lookups, advanced phonological transcriptions, and more with Readerum Premium.",
    BOOKINFO_LOGIN_REQUIRED_FOR_LIST: "Log in to save books to your list.",

    // FAQ Accordion
    INDEX_FAQ_TITLE: "Frequently Asked Questions",
    INDEX_FAQ_QUESTION1: "What is Readerum?",
    INDEX_FAQ_ANSWER1: "Readerum is a reading platform where you can find every kind of book, as well as dictionaries, phonology tools, and automatic reading.",
    INDEX_FAQ_QUESTION2: "How can I access Readerum?",
    INDEX_FAQ_ANSWER2: "You can access Readerum with your email account or through your favorite social networks.",
    INDEX_FAQ_QUESTION3: "How much does Readerum cost?",
    INDEX_FAQ_ANSWER3: "Readerum costs {PRICE} {MONEY_SYMBOL} per year, which equals about {PRICE_BY_MONTH} {MONEY_SYMBOL} per month.",
    INDEX_FAQ_QUESTION4: "On which devices can I use Readerum?",
    INDEX_FAQ_ANSWER4: "You can use Readerum on any device with an internet connection and a web browser.",
    INDEX_FAQ_QUESTION5: "Is there any commitment to stay subscribed?",
    INDEX_FAQ_ANSWER5: "No. You can cancel your subscription at any time and the cancellation takes effect at the end of your billing period.",
    INDEX_FAQ_QUESTION6: "How do I cancel the service?",
    INDEX_FAQ_ANSWER6: "Readerum has no permanence contracts. You can manage your account online in just a few clicks, without extra fees, and activate or cancel whenever you want.",
    // Dispositivos disponibles
    DEVICES_TITLE: "Available devices",
    DEVICES_GOOGLE_PLAY_TITLE: "Google Play",
    DEVICES_GOOGLE_PLAY_DESC: "Available on Google Play",
    DEVICES_WEB_TITLE: "Web browser",
    DEVICES_WEB_DESC: "Available on any modern browser",
    DEVICES_ANDROID_TV_TITLE: "Android TV",
    DEVICES_ANDROID_TV_DESC: "Compatible with Android TV",
    // Formulario de contacto
    CONTACT_FORM_TITLE: "Contact us",
    CONTACT_FORM_DESC: "Do you have a question or problem? We're here to help! Fill out the form below and we'll contact you as soon as possible.",
    CONTACT_FORM_NAME: "Name",
    CONTACT_FORM_EMAIL: "Email",
    CONTACT_FORM_MESSAGE: "Message",
    CONTACT_FORM_MESSAGE_PLACEHOLDER: "Write your message here...",
    CONTACT_FORM_SUBMIT: "Send",
    CONTACT_FORM_ERROR: "Please complete all fields.",
    CONTACT_FORM_INVALID_EMAIL: "Please enter a valid email address.",
    CONTACT_FORM_SUBMIT_ERROR: "Something went wrong while sending the form. Please try again later.",
    CONTACT_FORM_SUBMIT_SUCCESS: "Message sent successfully! We'll contact you as soon as possible.",
    CONTACT_FORM_ENCOURAGEMENT: "Your opinion is very important to us. Tell us how we can improve.",
    // Footer
    FOOTER_INDEX: "Home",
    FOOTER_PRIVACY: "Privacy policy",
    FOOTER_TERMS_OF_USE: "Terms of use",
    FOOTER_CUSTOMER: "Customer support",
    FOOTER_HELP_US: "Help us improve",
    FOOTER_ABOUT_US: "About us",
    FOOTER_COPYRIGHT: "All rights reserved",
    FOOTER_READERUM_TEXT: "Readerum.com (c) 2025",

    // Login
    LOGIN_TITLE: "Log in",
    LOGIN_EMAIL: "Email",
    LOGIN_PASSWORD: "Password",
    LOGIN_BUTTON: "Log in",
    LOGIN_GOOGLE: "Sign in with Google",
    LOGIN_FACEBOOK: "Sign in with Facebook",
    LOGIN_NO_ACCOUNT: "Don't have an account?",
    LOGIN_REGISTER: "Register here",
    LOGIN_LOADING: "Loading...",
    LOGIN_ERROR_USER_NOT_FOUND: "User not found. Please check your credentials.",
    LOGIN_ERROR_WRONG_PASSWORD: "Incorrect password. Please check your credentials.",
    LOGIN_ERROR_INVALID_EMAIL: "Invalid email. Please check your email address.",
    LOGIN_ERROR_EMAIL_ALREADY_IN_USE: "This email is already in use. Please try another one.",
    LOGIN_ERROR_WEAK_PASSWORD: "The password is too weak. Please choose a stronger one.",
    LOGIN_ERROR_DEFAULT: "Something went wrong. Please try again later.",

    // Register
    REGISTER_TITLE: "Sign up",
    REGISTER_EMAIL: "Email",
    REGISTER_PASSWORD: "Password",
    REGISTER_BUTTON: "Create account",
    REGISTER_HAVE_ACCOUNT: "Already have an account?",
    REGISTER_LOGIN: "Log in here",
    REGISTER_FIRST_NAME: "First name",
    REGISTER_LAST_NAME: "Last name",
    REGISTER_LOADING: "Registering...",
    REGISTER_ERROR_WEAK_PASSWORD: "The password is too weak. Please choose a stronger one.",
    REGISTER_ERROR_INVALID_EMAIL: "Invalid email. Please check your email address.",
    REGISTER_ERROR_EMAIL_ALREADY_IN_USE: "This email is already in use. Please try another one.",
    REGISTER_ERROR_DEFAULT: "Something went wrong. Please try again later.",
    REGISTER_SUCCESS: "Account created successfully! Please log in to continue.",

    // Pricing
    PRICING_HEADER_TITLE: "Read, listen and learn in a new way.",
    PRICING_HEADER_SUBTITLE: "Readerum accompanies you with every word: reading, audio and dictionary all in one place.",
    PRICING_FOOTER_NOTE: "Limits may change by country or campaign. Taxes included where applicable.",
    PRICING_PLAN_FREE_NAME: "Free plan",
    PRICING_PLAN_FREE_DESCRIPTION: "Full experience with monthly limits.",
    PRICING_PLAN_FREE_BADGE: "Popular",
    PRICING_PLAN_FREE_FEATURE_BOOKS: "1 full book per month",
    PRICING_PLAN_FREE_FEATURE_AUDIO: "Full audio (no speed controls)",
    PRICING_PLAN_FREE_FEATURE_DICTIONARY: "Unlimited dictionary for those readings",
    PRICING_PLAN_FREE_FEATURE_SYNC: "Progress bar synchronization",
    PRICING_PLAN_FREE_FEATURE_CUSTOMIZATION: "Basic personalization",
    PRICING_PLAN_FREE_PRICE: "0 {MONEY_SYMBOL}",
    PRICING_PLAN_FREE_NOTE: "Registration required",
    PRICING_PLAN_FREE_CTA: "Choose Free plan",
    PRICING_PLAN_PREMIUM_NAME: "Premium",
    PRICING_PLAN_PREMIUM_DESCRIPTION: "Unlimited reading and advanced features.",
    PRICING_PLAN_PREMIUM_BADGE: "All inclusive",
    PRICING_PLAN_PREMIUM_FEATURE_LIBRARY: "Unlimited catalog and audio",
    PRICING_PLAN_PREMIUM_FEATURE_SPEED: "Speed control 0.5-1.5x plus autoplay",
    PRICING_PLAN_PREMIUM_FEATURE_HIGHLIGHT: "Word-by-word highlighting across the text",
    PRICING_PLAN_PREMIUM_FEATURE_STATS: "Reading analytics",
    PRICING_PLAN_PREMIUM_FEATURE_FONOLOGY: "Phonology text in available languages",
    PRICING_PLAN_PREMIUM_FEATURE_COLLECTIONS: "Premium collections and priority support",
    PRICING_PLAN_PREMIUM_PRICE: "4.99 {MONEY_SYMBOL}",
    PRICING_PLAN_PREMIUM_PERIOD: "month",
    PRICING_PLAN_PREMIUM_NOTE: "or 39.99 {MONEY_SYMBOL} / year",
    PRICING_PLAN_PREMIUM_CTA: "Go Premium",

    // PRIVACY POLICY
    PRIVACY_TITLE: "Privacy policy",
    PRIVACY_DATE_DESC: "Last updated:",
    PRIVACY_DATE: "2025-03-22",
    PRIVACY_EMAIL: "privacy@readerum.com",
    PRIVACY_RESUME: "At Readerum, protecting your data is our top priority. Below we explain how we collect, store, and use your personal information. If you have any questions or concerns, please contact us.",
    PRIVACY_TEXT: "<li><strong>Who is responsible for processing your data?</strong>\n " +
    "Readerum is responsible for processing personal data. You can contact our Data Protection Officer at any time by emailing {PRIVACY_EMAIL}." +
    "</li>\n" +

    "<li><strong>What data do we collect?</strong>\n"+
    "We only collect the data necessary to provide you with the service in an efficient and personalized way. This includes:" +
    "<ul>" +
      "<li>Authentication data: when you sign in with Google or Facebook (via Firebase) we receive your name, email, and public profile photo. We never access or store your password." +
      "<li>Reading preferences: such as audio speed, font size, preferred language, or dictionary used." +
      "<li>Technical data: device type, operating system, and app version for analysis and support." +
      "<li>Anonymous or aggregated usage data to improve performance and functionality." +
      "<li>We do not collect sensitive information (such as precise location, phone number, address, financial or medical data)." +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>What do we use your data for?</strong>\n" +
    "We use your personal data to:" +
    "<ul>" +
      "<li>Allow and manage sign-in and authentication." +
      "<li>Save your preferences to personalize your experience." +
      "<li>Perform technical and functional analysis to improve the service." +
      "<li>Contact you when necessary (for example, support or important updates)." +
      "<li>Comply with legal obligations." +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>Who do we share your data with?</strong>\n" +
    "Readerum does not sell or rent your personal data. We only share it with third parties when:" +
    "<ul>" +
      "<li>It is required for the platform to operate, for example Firebase (Google) services that provide authentication, hosting, and database." +
      "<li>It is required by law, or by a judicial or administrative authority." +
      "<li>There is a merger, acquisition, or change of control, in which case we will notify you in advance." +
      "<li>All third parties comply with security and privacy standards equivalent to ours." +
    "</ul>" +
    "</li>\n" +

    "<li><strong>Where and for how long do we store your data?</strong>\n" +
    "Your data is stored on secure Firebase servers (located in the U.S. or other regions with adequate data protection safeguards). We keep your data only for as long as necessary for the purposes described in this policy, or until you request its deletion." +
    "</li>\n" +
    
    "<li><strong>What are your rights?</strong>\n" +
    "You have the right to:" +
    "<ul>"+
      "<li>Access your personal data." +
      "<li>Correct or update it." +
      "<li>Request deletion (right to be forgotten)." +
      "<li>Withdraw your consent." +
      "<li>Request portability of your data." +
      "<li>To exercise these rights, email us at {PRIVACY_EMAIL}. If you are in Colombia you can file a complaint with the Superintendence of Industry and Commerce (SIC). If you are in the EU, contact your local data protection authority." +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>Minors</strong>\n" +
    "Readerum is not aimed at children under 13. We do not knowingly collect data from children. If we discover that we have stored data from a minor without parental or guardian consent, we will delete it immediately." +
    "</li>\n" +

    "<li><strong>Cookies and similar technologies</strong>" +
    "On the Readerum web version we may use cookies or similar technologies to:" +
    "<ul>" +
      "<li>Remember your preferences.</li>" +
      "<li>Analyze site usage.</li>" +
      "<li>Improve performance.</li>" +
      "<li>You can control cookies from your browser settings.</li>" +
    "</ul>" +
    "</li>\n" +
    
    "<li><strong>Changes to this policy</strong>\n" + 
    "We may update this policy in the future. If we make significant changes we will notify you through the app or by email." +
    "</li>\n",

    // TERMS OF USE
    TERMS_OF_USE_TITLE: "Terms and conditions of use",
    TERMS_OF_USE_RESUME: "Welcome to Readerum. By accessing or using our online reading platform you agree to these terms and conditions. If you disagree with any part, please do not use the site or services.",
    TERMS_OF_USE_DATE: "2025-03-22",
    TERMS_DATE_DESC: "Last updated: {TERMS_OF_USE_DATE}",
    TERMS_OF_USE_TEXT: "<ol>" +
    "<li><strong>Service description.</strong> " +
      "Readerum is an online platform that offers a wide selection of books in several languages. Our goal is to promote reading and learning through a simple, engaging experience accessible from any internet-connected device." +
    "</li>\n"+
    "<li><strong>Registration and access.</strong> " +
      "Some features require creating a personal account. " +
      "When you register you agree to provide truthful, complete, and up-to-date information. " + 
      "You are responsible for keeping your login credentials confidential and for any activity that occurs under your account." +
    "</li>\n"+
    "<li><strong>Proper use.</strong> " +
    "When using Readerum you agree to:" +
      "<ul>" +
        "<li>Not use the platform for illegal or unauthorized purposes." +
        "<li>Not copy, reproduce, or distribute content without authorization unless stated otherwise." +
        "<li>Not interfere with the normal functioning of the site or perform actions that may compromise its security or stability." +
      "</ul>" +
    "</li>\n" +
    "<li><strong>Intellectual property.</strong> " +
      "All content available on Readerum (texts, images, interface, code, etc.) belongs to Readerum or its licensors. " +
      "Use of the content is restricted to personal and educational purposes unless expressly authorized otherwise." +
    "</li>\n" +
    "<li><strong>Third-party content.</strong> " +
      "Readerum may include links, references, or content provided by third parties. We are not responsible for the content, policies, or practices of external sites." +
    "</li>\n" +
    "<li><strong>Service availability.</strong> " +
      "We make reasonable efforts to guarantee continuous availability of the service, but we are not responsible for temporary interruptions, technical failures, or other situations that prevent access." +
    "</li>\n" +
    "<li><strong>Modifications.</strong> " +
      "We reserve the right to modify these terms at any time. For significant changes we will notify users through the platform or by email. Continued use after the update implies acceptance of the new terms." +
    "</li>\n" +
    "<li><strong>Termination.</strong> " +
      "Readerum may suspend or cancel your access, temporarily or permanently, if you breach these terms or if inappropriate use is detected." +
    "</li>\n" +
    "<li><strong>Limitation of liability.</strong> " +
      "Readerum is not liable for direct, indirect, incidental, or consequential damages arising from the use or inability to use the service. Readerum is provided \"as is\" and \"as available\"." +
    "</li>\n" +
    "<li><strong>Applicable law and jurisdiction.</strong> " +
      "These terms are governed by the laws of the Republic of Colombia. In case of disputes, the parties submit to the competent courts of Bogota." +
    "</li>",

    // CUSTOMER SUPPORT
    CUSTOMER_SUPPORT_TITLE: "Customer support",
    CUSTOMER_SUPPORT_TEXT: "Welcome to our customer support center. We're here to help you with any question or issue. Find quick answers in our FAQs or contact our customer support team.",
    // HELP US IMPROVE
    HELP_US_TITLE: "Help us improve",
    HELP_US_TEXT: "At Readerum we are committed to continuously improving our platform to offer you the best possible reading experience. If you have any suggestions, comments, or issues, please let us know.",
    // ABOUT US
    ABOUT_US_TITLE: "About us",
    ABOUT_US_TEXT: "Readerum is an online reading platform that offers a wide selection of books in several languages. Our goal is to encourage reading and learning through a simple and engaging user experience, making reading accessible and dynamic for everyone.",



    // HOME
    // Navbar
    HOME_MENU_HOME: "HOME",
    HOME_MENU_MY_LIST: "MY LIST",
    HOME_MENU_SEARCH: "SEARCH",
    HOME_MENU_SETTINGS: "Settings",
    HOME_LOGOUT_BUTTON: "Log out",
    // GLOBAL SETTTINGS
    SETTINGS_PANEL_TITLE: "Global settings",
    SETTINGS_LANGUAGE_LABEL: "Interface language",
    SETTINGS_LANGUAGE_SPANISH: "Spanish",
    SETTINGS_LANGUAGE_ENGLISH: "English",
    SETTINGS_FEEDBACK_CTA: "Help us improve",
    SETTINGS_FEEDBACK_TITLE: "We'd love your feedback",
    // Tags (Given for the API)
    MOST_READ_LABEL: "Most read",
    LASTEST_LABEL: "Recently uploaded",
    LASTEST_LABEL1: "Recently uploaded",
    LASTEST_LABEL2: "Recently uploaded",

    // Book info
    SHOW_BOOK_RESUME: "Show summary",
    HIDE_BOOK_RESUME: "Hide summary",
    BOOKINFO_STATUS_LABEL: "Status in My List",
    BOOKINFO_ADD_BUTTON: "Save",
    BOOKINFO_ADDING: "Saving...",
    BOOKINFO_ADD_SUCCESS: "Book saved to your list.",
    BOOKINFO_ADD_ERROR: "We couldn't save the book. Please try again.",

    // Book chapter
    // Menu
    CHAPTER_BACK: "Back",
    CHAPTER_PLAY: "Play",
    CHAPTER_PREV: "Previous",
    CHAPTER_NEXT: "Next",
    // Menu settings
    CHAPTER_SETTINGS_TITLE: "Preferences",
    CHAPTER_SETTINGS_AUDIO: "Audio",
    CHAPTER_SETTINGS_DICTIONARY: "Dictionary",
    CHAPTER_SETTINGS_TEXT: "Text",
    CHAPTER_DIALECT: "Dialect",
    CHAPTER_DIALECT_ICON: "Dialect icon",
    CHAPTER_SPEED: "Speed",
    CHAPTER_SPEED_ICON: "Speed icon",
    CHAPTER_AUTO_PLAY: "Autoplay",
    CHAPTER_AUTO_PLAY_ICON: "Autoplay icon",
    CHAPTER_AUTO_PLAY_DESC: "When one chapter ends, the next one starts automatically.",
    CHAPTER_DICTIONARY_LAGUAGE: "Dictionary language",
    CHAPTER_DICTIONARY_LAGUAGE_ICON: "Dictionary language icon",
    CHAPTER_SHOW_PHONOLOGY: "Phonology",
    CHAPTER_SHOW_PHONOLOGY_ICON: "Phonology icon",
    CHAPTER_SHOW_PHONOLOGY_DESC: "Show the phonology under each word in the text.",
    CHAPTER_TEXT_SIZE: "Text size",
    CHAPTER_TEXT_SIZE_ICON: "Text size icon",
    CHAPTER_AUTOSCROLL_RESUME: "Enable auto-scroll",
    CHAPTER_TS_CHARACTER: "A",

    // Ambient Sound
    AMBIENT_TITLE: "Ambient Sound",
    AMBIENT_OFF: "Off",
    AMBIENT_RAIN: "Rain",
    AMBIENT_FOREST: "Forest",
    AMBIENT_FIREPLACE: "Fireplace",
    AMBIENT_CAFE: "Cafe",
    AMBIENT_SEA: "Sea",

    // ERRORS
    CHAPTER_ERROR_GETTING_DATA: "Error fetching chapter data",
    CHAPTER_UNKNOWN_ERROR_GETTING_DATA: "Unknown error while fetching chapter data",
    CHAPTER_ERROR_LOADING_AUDIO_DATA_FOR_NEW_DIALECT: "Error loading audio data for the new dialect",
    CHAPTER_ERROR_AUTOPLAY_AUDIO: "Error trying to autoplay the audio:",
    // Modal definition
    LEMMA_MODAL_LOADING: "Loading...",
    LEMMA_MODAL_CLOSE: "Close and continue",
    LEMMA_MODAL_JUST_CLOSE: "Close without continuing audio",
    LEMMA_MODAL_NOT_FOUND: "Lemma not found.",
    LEMMA_MODAL_API_ERROR: "API error.",
    LEMMA_MODAL_NETWORK_ERROR: "Network error.",
    LEMMA_MODAL_NO_DATA: "No data available.",
    LEMMA_MODAL_PROPER_NOUNS: "Proper nouns",
    LEMMA_MODAL_ETYM: "Etymology",
    LEMMA_MODAL_MORPH: "Morphology",
    LEMMA_MODAL_ROOT: "Root",
    LEMMA_MODAL_VIEW_PLANAR: "Planar",
    LEMMA_MODAL_VIEW_FRACTAL: "Fractal (AI)",
    LEMMA_MODAL_SHOW_DETAILS: "Show linguistic details",
    LEMMA_MODAL_HIDE_DETAILS: "Hide details",
    // Dialect translations
    'es-ES': "Spanish (Spain)",
    'es-419': "Spanish (Latin America)",

    // Login Modal
    INDEX_LOGIN_TITLE: "Sign in",
    INDEX_EXTERNAL_LOGIN: "Sign in with {PLATFORM}",
    INDEX_LOGIN_WITH_EMAIL: "Register with your email",
    INDEX_LOGIN_BUTTON: "Sign in",
    INDEX_HAVE_AN_ACCOUNT: "Already have an email account?",
    INDEX_LOGIN_TEXT: "Log in",


    // Search
    SEARCH_TITLE: "Find your next read",
    SEARCH_SUBTITLE: "Type a title, author, or keyword to explore the library.",
    SEARCH_PLACEHOLDER: "Search by title, author, or topic",
    SEARCH_BUTTON: "Search",
    SEARCH_RESULTS_TITLE: "Results",
    SEARCH_RESULTS_EMPTY: "We couldn't find matches for \"{QUERY}\".",
    SEARCH_RESULTS_SUGGESTION: "Try other keywords or explore the featured recommendations.",
    SEARCH_RESULT_LANGUAGE: "Language",
    SEARCH_RESULT_CATEGORY: "Category",
    SEARCH_RESULT_VIEW: "View book",
    SEARCH_RESULTS_COUNT_LABEL: "Found {COUNT} results:",
    SEARCH_MIN_CHARS_HINT: "Type at least 4 characters to start the search.",
    SEARCH_ERROR_NO_BOOKS_FOUND: "We couldn't find books related to your search.",
    SEARCH_GENERIC_ERROR: "We couldn't complete the search. Please try again.",
    SEARCH_RESULT_UNTITLED: "Untitled",
    SEARCH_RESULT_LANGUAGE_UNKNOWN: "Unknown language",
    SEARCH_RESULT_CATEGORY_UNKNOWN: "Uncategorized",
    // SEARH API RESPONSES
    API_NO_BOOKS_FOUND: "We couldn't find books related to your search.",


    // LIST
    LIST_TITLE: "My list",
    LIST_INTRO: "You have {TOTAL} books in your personal library.",
    LIST_SUMMARY_QUEUED: "Queued",
    LIST_SUMMARY_QUEUED_HINT: "Books in queue.",
    LIST_SUMMARY_IN_PROGRESS: "In progress",
    LIST_SUMMARY_IN_PROGRESS_HINT: "Currently reading.",
    LIST_SUMMARY_FINISHED: "Finished",
    LIST_SUMMARY_FINISHED_HINT: "Completed books.",
    LIST_FILTER_TITLE: "Find your next read",
    LIST_FILTER_SEARCH_LABEL: "Search",
    LIST_FILTER_SEARCH_PLACEHOLDER: "Title or author",
    LIST_FILTER_SEARCH_BUTTON: "Go",
    LIST_FILTER_LANGUAGE_LABEL: "Language",
    LIST_FILTER_LANGUAGE_ALL: "All languages",
    LIST_FILTER_STATUS_LABEL: "Status",
    LIST_FILTER_STATUS_ALL: "All statuses",
    LIST_FILTER_STATUS_IN_PROGRESS: "In progress",
    LIST_FILTER_STATUS_FINISHED: "Finished",
    LIST_FILTER_STATUS_QUEUED: "Queued",
    LIST_FILTER_SORT_LABEL: "Sort by",
    LIST_FILTER_SORT_RECENT: "Last opened",
    LIST_FILTER_SORT_TITLE: "Title (A-Z)",
    LIST_FILTER_SORT_AUTHOR: "Author (A-Z)",
    LIST_FILTER_SORT_STATUS: "Status",
    LIST_FEATURED_TITLE: "Pick up where you left off",
    LIST_FEATURED_SUBTITLE: "Last session: {DATE}",
    LIST_BOOKS_SECTION_TITLE: "Your saved bookshelf",
    LIST_BOOKS_SECTION_COUNT: "{COUNT} books",
    LIST_EMPTY_TITLE: "Nothing matches your filters",
    LIST_EMPTY_SUBTITLE: "Adjust the filters or explore the full catalogue.",
    LIST_CARD_REMOVE: "Remove",
    LIST_CARD_REMOVING: "Removing...",
    LIST_STATUS_IN_PROGRESS: "In progress",
    LIST_STATUS_FINISHED: "Finished",
    LIST_STATUS_QUEUED: "Queued",
    LIST_STATUS_NOT_STARTED: "Not started",
    LIST_LOADING: "Loading your list...",
    LIST_ERROR: "We couldn't load your list. Please try again later.",
    LIST_REMOVE_SUCCESS: "Book removed from your list.",
    LIST_REMOVE_ERROR: "We couldn't remove the book. Please try again.",
  },

};

export default translations;







